import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { getTimezone } from '../../../utils/timezone';
import TaskBulkActionsPage from '../../../features/tasks/components/TaskBulkActionsPage';
import {
  getAgencyTaskBulkActionsRoute,
  getAgencyTasksRoute,
} from '../../../features/tasks/constants/taskFields';

export default function AgencyTaskBulkActionsPage() {
  const { agencyId } = useParams();
  const { user } = useAuth();
  const workspace = useMemo(() => ({
    scopeType: 'agency',
    platformId: user?.platform_id || null,
    agencyId,
    timezone: user?.timezone || getTimezone() || 'UTC',
    permissions: user?.permissions || [],
    routes: {
      tasks: getAgencyTasksRoute(agencyId),
      bulkActions: getAgencyTaskBulkActionsRoute(agencyId),
    },
  }), [user, agencyId]);

  return <TaskBulkActionsPage workspace={workspace} />;
}
